const {
  USER_SESSION_INFO,
  OB_VISITOR_IDENTITY,
  OB_VISITOR_ID,
  OB_VISITOR_REQ_ID,
} = require('../../constants/cookieConstants');
const { getUserByVisitorId } = require('../utils/apis');

const IDENTITY_SOURCES = {
  COOKIE: 1,
  SESSION: 2,
  FINGERPRINT: 3,
};
class IdentityResolver {
  #session = null;

  #fingerprint = null;

  #cookies = null;

  #userIdentifier = getUserByVisitorId;

  #defaultLoginType = 'email';

  constructor({ session, fingerprint, cookies, userIdentifier }) {
    this.#session = session;
    this.#fingerprint = fingerprint;
    this.#cookies = cookies;

    if (userIdentifier) {
      this.#userIdentifier = userIdentifier;
    }
  }

  async resolve() {
    const { ip, isBot: bot, trusted, provider } = this.#fingerprint || {};
    const sessionInfo = this.#session?.get(USER_SESSION_INFO) || {};
    const authenticated = !!sessionInfo?.user?.id;
    const visitorId = this.#cookies?.[OB_VISITOR_ID] || '';
    const requestId = this.#cookies?.[OB_VISITOR_REQ_ID] || '';
    const savedVisitorIdentity = this.#cookies?.[OB_VISITOR_IDENTITY];

    let user = null;
    let identitySource = null;

    if (!user && savedVisitorIdentity) {
      const userInfo = JSON.parse(savedVisitorIdentity);

      if (userInfo?.id && userInfo?.email && userInfo?.name) {
        user = {
          id: userInfo.id,
          email: userInfo.email,
          name: userInfo.name,
          loginType: userInfo.loginType || this.#defaultLoginType,
        };
        identitySource = IDENTITY_SOURCES.COOKIE;
      }
    }

    if (!user && authenticated && sessionInfo?.user?.id && sessionInfo?.user?.email && sessionInfo?.user?.name) {
      let loginType = null;

      if (savedVisitorIdentity) {
        const userInfo = JSON.parse(savedVisitorIdentity);
        loginType = userInfo?.loginType;
      }

      user = {
        id: sessionInfo?.user?.id,
        email: sessionInfo?.user?.email,
        name: sessionInfo?.user?.name,
        loginType: loginType || this.#defaultLoginType,
      };
      identitySource = IDENTITY_SOURCES.SESSION;
    }

    if (!user && visitorId && !bot) {
      const response = await this.#userIdentifier({ visitorId }, this.#session);
      const visitorData = response?.data?.[0] || {};

      user = {
        id: visitorData?.user?.id,
        email: visitorData?.user?.email,
        name: visitorData?.user?.name,
        loginType: visitorData?.user?.auth_via || this.#defaultLoginType,
      };
      identitySource = IDENTITY_SOURCES.FINGERPRINT;
    }

    return {
      visitorId,
      requestId,
      ip,
      bot,
      trusted,
      provider,
      authenticated,
      user,
      source: identitySource,
    };
  }
}

module.exports = IdentityResolver;
